import {
    SHOW_MODAL_DIALOG,
    HIDE_MODAL_DIALOG
} from './consts';

export function show(dispatch, msg, title) {
    dispatch({
        type   : SHOW_MODAL_DIALOG,
        payload: {
            msg,
            show: true,
            title }
    });
}

export function hide(dispatch) {
    dispatch({
        type   : HIDE_MODAL_DIALOG,
        payload: {
            msg : null,
            show: false }
    });
}



// WEBPACK FOOTER //
// ./src/blocks/modal-dialog/actions.js